import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import { withHandlers } from 'recompose'
import { withStyles } from '@material-ui/core/styles'
import {
  STAGE_BREAK_CHOICE,
  STAGE_TASK_CHOICE,
  STAGE_TASK_COUNTER,
} from 'constants'
import { timerStart, seconds, minutes, getMidnight } from 'utils/timer'
import {
  setCountdownValue,
  setDumoDesc,
  enterModalMode,
} from 'store/interactions'
import { taskingNowArray, breakingNowArray, usersTodayArray } from 'selectors'
import styles from './TaskPrompt.styles'

export default compose(
  firebaseConnect([
    {
      path: 'users',
      storeAs: 'usersToday',
      queryParams: [
        'parsed',
        `startAt=${getMidnight()}`,
        'orderByChild=lastSeen',
      ],
    },
  ]),
  connect(
    state => {
      const { interactions, firebase } = state
      const { profile } = firebase
      const { uid } = profile

      return {
        usersTodayArray: usersTodayArray(state),
        taskersNow: taskingNowArray(state),
        breakersNow: breakingNowArray(state),
        dumoFieldValue: interactions.dumoFieldValue,
        dumoDesc: profile.dumoDesc || '',
        stage: profile.stage || STAGE_TASK_CHOICE,
        uid: uid || '',
        modalMode: interactions.modalMode,
      }
    },
    (dispatch, props) => ({
      saveInput: desc => dispatch(setDumoDesc(desc)),
      updateCounter: val => dispatch(setCountdownValue(val)),
      popout: () => {
        window.open('/', 'DUMO', 'width=500,height=800', true)
        window.focus()
        dispatch(enterModalMode())
      },
    })
  ),
  withHandlers({ startDumoTimer }),
  withStyles(styles)
)

function startDumoTimer(props) {
  return coords => {
    const { firebase, dumoFieldValue, updateCounter } = props
    const mins = 25

    const now = Date.now()

    if (coords && coords.lat && coords.lng) {
      firebase.updateProfile({
        stage: STAGE_TASK_COUNTER,
        dumoDesc: dumoFieldValue,
        lastSeen: now,
        lat: coords.lat,
        lng: coords.lng,
      })
    } else {
      firebase.updateProfile({
        stage: STAGE_TASK_COUNTER,
        dumoDesc: dumoFieldValue,
        lastSeen: now,
      })
    }

    return timerStart({
      interval: seconds(1),
      duration: minutes(mins),
      intervalFn: updateCounter,
    }).then(() => {
      firebase.updateProfile({
        stage: STAGE_BREAK_CHOICE,
        lastSeen: now,
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/TaskPrompt/TaskPrompt.enhancer.js